import React, { useEffect } from "react";
import "./Unique_Collection.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import { useNavigate } from "react-router-dom";

const Unique_Collection = () => {
  const data = [
    {
      img: "/assets/images/cats/cat1.png",
      label: "Mattresses",
    },
    {
      img: "/assets/images/cats/cat2.png",
      label: "Pillows",
    },
    {
      img: "/assets/images/cats/cat3.png",
      label: "Accessories",
    },
  ];

  const uniquecollection = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, []);

  // console.log(uniquecollection,"categories")
  const navigate = useNavigate();
  const handleCategoryClick = (id, product, img) => {
    navigate(
      `/product-listing/${id}?category_name=${encodeURIComponent(
        product,
      )}&category_image=${encodeURIComponent(img)}`,
    );
    // }
  };
  return (
    <section className="Unique_Collection">
      <div className="container">
        <Common_Title title={"Unique Collections, Crafted for Everyone."} />

        <div className="content_div">
          <Swiper
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: { slidesPerView: 1.2, spaceBetween: 10 },
              360: { slidesPerView: 1.2, spaceBetween: 10 },
              425: { slidesPerView: 2.1, spaceBetween: 10 },
              640: { slidesPerView: 2.1, spaceBetween: 10 },
              768: { slidesPerView: 2.5, spaceBetween: 15 },
              992: { slidesPerView: 2.8, spaceBetween: 15 },
              1200: { slidesPerView: 3, spaceBetween: 15 },
              1400: { slidesPerView: 3, spaceBetween: 20 },
            }}
            className="mySwiper"
          >
            {uniquecollection?.map((val) => (
              <SwiperSlide>
                <div className="card_div">
                  <div
                    className="img_div"
                    onClick={() =>
                      handleCategoryClick(val?.id, val?.name, val?.image)
                    }
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      className="inner_img"
                    />
                  </div>
                  <p className="cat_name">{val?.name}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Unique_Collection;
